import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names using clsx and tailwind-merge.
 * Handles conditional classes and resolves Tailwind conflicts.
 * @param  {...any} inputs - Class name values (strings, objects, arrays)
 * @returns {string} Merged class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a decimal JOD amount as currency.
 * @param {number} amount - JOD decimal value
 * @param {string} locale - 'ar-JO' or 'en-JO'
 * @returns {string}
 */
export function formatJOD(amount, locale = 'ar-JO') {
  const value = typeof amount === 'number' && isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'JOD',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(value);
}

/**
 * Format an integer fils amount (1 JOD = 1000 fils) as JOD currency.
 * All monetary values stored in the database use integer fils.
 * @param {number} fils - integer fils value
 * @param {string} locale - 'ar-JO' or 'en-JO'
 * @returns {string}
 */
export function formatFils(fils, locale = 'ar-JO') {
  const amount = (fils || 0) / 1000;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'JOD',
    minimumFractionDigits: 3,
  }).format(amount);
}

/**
 * Format a date string for Jordanian locale.
 * @param {string|Date} date
 * @param {string} locale - 'ar-JO' or 'en-JO'
 * @returns {string}
 */
export function formatDate(date, locale = 'ar-JO') {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
}
